export default "__VITE_ASSET__328de88c__"